module.exports = __webpack_public_path__ + "media/stylesheets/images/start_@2X-6aa77f3eaf4edc41f0ae1d770cd56418.png";